@use 'src/scss/mixins/button';
@use 'src/scss/mixins/controls';
@use 'src/scss/elements/styledButton';

@use 'src/scss/config/index' as config;

.container {
  padding: 1.6rem;
  text-align: center;
  display: grid;
  grid-template-areas: 'header header' 'nav main' 'nav footer';
  grid-template-columns: min-content auto;
  grid-gap: 1.6rem;

  @media #{config.$md} {
    display: block;
  }
}

.header {
  grid-area: header;
}

.title {
  font-size: 2em;
}
